export default __webpack_public_path__ + "static/media/login-background-primary.5fca6319.png";